import React from 'react';
import { GridFilterInputValueProps } from '@mui/x-data-grid-pro';

import SelectFilter from './SelectFilter';
import {
  QC_ISSUE_CATEGORY_LABELS,
  QC_ISSUE_CATEGORY_ORDER,
  QC_ISSUE_STATUS_LABELS,
  QcIssueStatus,
} from '../../interfaces/qcIssue.interface';

// Drafts never appear in the admin QC Issues grid, so they are not filter options.
const STATUS_OPTIONS = (['pending_assessor_action', 'ready_for_tpn_review', 'needs_update', 'approved'] as QcIssueStatus[])
  .map((status) => ({ value: status, label: QC_ISSUE_STATUS_LABELS[status] }));

const CATEGORY_OPTIONS = QC_ISSUE_CATEGORY_ORDER
  .map((category) => ({ value: category, label: QC_ISSUE_CATEGORY_LABELS[category] }));

export function QcIssueStatusFilter(props: GridFilterInputValueProps) {
  return <SelectFilter {...props} options={STATUS_OPTIONS} />;
}

export function QcIssueCategoryFilter(props: GridFilterInputValueProps) {
  return <SelectFilter {...props} options={CATEGORY_OPTIONS} />;
}
